import * as Yup from "yup";

export default interface ResetPasswordFields {
    oldPassword: string
    newPassword: string
    confirmPassword: string
}

export const ResetPasswordFormValidation = Yup.object({
    oldPassword: Yup.string()
        .required("Old password is required")
        .min(6, "Password must be at least 6 characters")
        .max(200),

    newPassword: Yup.string()
        .required("New password is required")
        .min(8, "New password must be at least 8 characters")
        .max(200)
        .matches(/[A-Z]/, "Must contain at least one uppercase letter")
        .matches(/[a-z]/, "Must contain at least one lowercase letter")
        .matches(/\d/, "Must contain at least one number")
        .matches(/[^A-Za-z0-9]/, "Must contain at least one special character"),

    confirmPassword: Yup.string()
        .required("Please confirm your new password")
        .oneOf([Yup.ref("newPassword")], "Passwords do not match"),
});
